import 'Styles/templates/search.scss';
import initInstantSearchPage from '../search/instantsearch';

initInstantSearchPage();
